/**
 * The user Datadog RUM is told about. An opaque id and a type, nothing else:
 * no email, no name, no username. Email and name are personal data for
 * athletes and organisers alike, and Datadog does not need them to group a
 * session or an error by user. Support can look the id up in our own admin.
 *
 * The ids are already opaque: a participant account id is a random UUID and
 * a Clerk user id is a random "user_..." string. Neither is a credential, so
 * neither needs hashing.
 */

export interface RumUser {
  id: string;
  type: 'athlete' | 'organiser';
}

/** Anything with an id; every other field (email, names) is ignored. */
interface WithId {
  id: string;
}

export function rumUserForAthlete(participant: WithId): RumUser {
  return { id: participant.id, type: 'athlete' };
}

export function rumUserForOrganiser(user: WithId): RumUser {
  return { id: user.id, type: 'organiser' };
}
